import React, { useEffect } from 'react';
import {
  Container,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Page from 'src/components/Page';
import Header from './Header';
import { useDispatch, useSelector } from 'react-redux';
import MperitoCard from 'src/components/MperitoCard';
import Results from './Results';

import { fetchServices } from 'src/actions/serviceActions';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: 100
  }
}));

function ServicesList() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const businessInfo = useSelector((state) => state?.app?.businessInfo);
  const customerId = businessInfo?.customerId;

  const services = useSelector((state) => state?.service?.services);

  // console.log("ServicesList : ", services);
  
  useEffect(() => {
    dispatch(fetchServices(customerId));
  }, [businessInfo]);

  useEffect(() => {

  }, [services]);

  return (
    <Page
      className={classes.root}
      title="Services"
    >
      <Container maxWidth={false}>
        <Header />
        <br />
        <br />
        <MperitoCard title={`Services ( ${businessInfo?.businessName} - ${businessInfo?.customerId} )`}>
          <Results services={services} businessInfo={businessInfo} />
        </MperitoCard>
      </Container>
    </Page>
  );
}

export default ServicesList;

